var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "search_svg__cls-1",
    d: "M16.47 33.13a16.575 16.575 0 1 1 16.47-16.57 16.538 16.538 0 0 1-16.47 16.57Zm0-31.75a15.18 15.18 0 1 0 15.09 15.18A15.144 15.144 0 0 0 16.47 1.38Zm18.51 35.61-8.61-9.48 1.02-.94L36 36.04Z"
  })));
};
export default SvgSearch;